import React from 'react';

const Close = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.31333 1.39325C9.50847 1.19811 9.50847 0.881726 9.31333 0.686585C9.11819 0.491445 8.8018 0.491445 8.60666 0.686585L5 4.29325L1.39333 0.686586C1.19819 0.491445 0.881802 0.491445 0.686662 0.686585C0.491521 0.881726 0.491521 1.19811 0.686662 1.39325L4.29333 4.99992L0.686662 8.60658C0.491521 8.80173 0.491521 9.11811 0.686662 9.31325C0.881802 9.50839 1.19819 9.50839 1.39333 9.31325L5 5.70659L8.60666 9.31325C8.8018 9.50839 9.11819 9.50839 9.31333 9.31325C9.50847 9.11811 9.50847 8.80173 9.31333 8.60659L5.70666 4.99992L9.31333 1.39325Z"
        fill="#36354C"
      />
    </svg>
  );
};

export default Close;
